import { useFormatter } from 'next-intl';
import { useLocale } from 'next-intl';
import useHostMatch from '@/src/utils/useHostMatch';

export default function useFormatterPrice() {
  const appLocale = useLocale();
  const format = useFormatter();
  const isRawDomain = useHostMatch('atsauksjon.no');

  return (price: number, locale?: string, forceCurrency?: string) => {
    locale = locale ?? appLocale;
    let currencyType;
    if (forceCurrency) {
      currencyType = forceCurrency;
    } else {
      switch (locale) {
        case 'en':
          currencyType = isRawDomain ? 'NOK' : 'EUR';
          break;
        case 'de':
        case 'fi':
          currencyType = 'EUR';
          break;
        case 'sv':
          currencyType = 'SEK';
          break;
        case 'pl':
          currencyType = 'PLN';
          break;
        case 'no':
        default:
          currencyType = 'NOK';
          break;
      }
    }

    const formattedPrice =  `${price.toLocaleString(undefined, {
      style: 'currency',
      currency: currencyType,
      maximumFractionDigits: 0,
    })}`;

    return formattedPrice;
  };
}
